import React, { Component } from 'react';
import {getAllSuppliers} from '../store/actions/vendorActions'
import {getAllProjectNumber} from '../store/actions/projectNoActions'
import {getAllOrderNumber} from '../store/actions/orderNoActions'
import { getAllDetailsForDispatch} from '../store/actions/dispatchOrderDetailsActions'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import env from '../ENV';
import authInstance from '../Classes/AuthHandler';
import {connect} from 'react-redux'
import DropdownFlat from '../Components/DropdownFlat'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

// function formatDate(date) {
//     var d = new Date(date),
//     month = '' + (d.getMonth() + 1),
//     day = '' + d.getDate(),
//     year = d.getFullYear();
    
//     if (month.length < 2) 
//     month = '0' + month;
//     if (day.length < 2) 
//     day = '0' + day;
    
//     return [day, month, year].join('-');
//   }
  
 
  class DispatchHome extends React.Component {

    constructor(props) {
        super(props);
        this.state={
         
        supplierName: "ABC Tech Inc.",
        select: true,
        open: false,
        selectAll: false,
        checked: [],
        opacity:"",
        multiCollapseIndex:"", 
        selectedMethod:"",     
        Vendors : [],
        Orders:[],
        Projects:[],
        // Items:[],
        selectedVendor: "", selectedOrder: "", selectedProject: "",
        // selectedItem:""
      }
      
      this.togglebutton = this.togglebutton.bind(this); 
     }
    action1() {
        this.setState({ action1: false });
    }
    togglebutton=(Index)=> {  
        var multiCollapseIndex = this.state.multiCollapseIndex
    
        if(multiCollapseIndex!=Index || multiCollapseIndex==''){
          this.setState({multiCollapseIndex:Index})
      }  
    } 

    handleSelectSupplier=(e)=>{
      let selectedData= e.target.value
      this.setState({selectedVendor: selectedData})
    }    

    handleSelectOrder=(e)=>{
      let selectedData= e.target.value
      this.setState({selectedOrder: selectedData})
    }    

    handleSelectProject=(e)=>{
      let selectedData= e.target.value
      this.setState({selectedProject: selectedData})
    }
    // handleSelectItem=(e)=>{
    //   let selectedData= e.target.value
    //   this.setState({selectedItem: selectedData})
    // }

    handleSearch=()=>{
      this.props. getAllDetailsForDispatch({
        VendorId: this.state.selectedVendor,
        OrderId: this.state.selectedOrder,
        ProjectId: this.state.selectedProject,
        // ItemId: this.state.selectedItem
      })
    }

    handleRedo=()=>{
      window.location.reload()
    }

    
    componentDidMount(){ 
      var role=Object.keys(authInstance.getRoles())[0]
      if(role!=5) {
        this.props.getAllSuppliers()
        this.props.getAllDetailsForDispatch()
      }
      else{
        var vendorId= authInstance.getUserPayLoad().userId
        this.props.getAllDetailsForDispatch({
          VendorId: vendorId,
          OrderId: 0,
          ProjectId: 0
        })
      }
      this.props.getAllProjectNumber()
      this.props.getAllOrderNumber()
    
      }  

    render()
    {
      let Tabledata= []
        var roles = authInstance.getRoles()
        var groups = authInstance.getGroups()
        console.log("roles",authInstance.getUserID());
        console.log("roles",authInstance.getUserPayLoad());
        console.log(this.props.orderDetails.allOrderDetails.recordset,"oooooo")
        
        {this.props.orderDetails.allOrderDetails && this.props.orderDetails.allOrderDetails.recordset && this.props.orderDetails.allOrderDetails.recordset.length>0 && this.props.orderDetails.allOrderDetails.recordset.map((element,i)=>{
          if(roles[12]==true){
            if (element.Status == "Inspection Clearence"){
              Tabledata.push(element)
            }
          }
          if(roles[5]==true){
            if (element.Status == "Dispatch Clearence Generated"){
              Tabledata.push(element)
            }
          }
          if(roles[6]==true){
            if (element.Status == "Dispatch Documents Submitted"){
              Tabledata.push(element)
            }
          }
        })}

        console.log(Tabledata, "-------------------------------------")
        // let ItemNo = []
        // {this.props.supplier.allVendors && this.props.supplier.allVendors.recordset && this.props.supplier.allVendors.recordset.length>0 && this.props.supplier.allVendors.recordset.map((element,index)=>
        //   ItemNo.push(element)
        // )}
        let Vendors = []
        {this.props.supplier.allVendors && this.props.supplier.allVendors.recordset && this.props.supplier.allVendors.recordset.length>0 && this.props.supplier.allVendors.recordset.map((element,index)=>
          Vendors.push(element)
        )}

        let Orders = []
        {this.props.order.allOrderNumber && this.props.order.allOrderNumber.recordset && this.props.order.allOrderNumber.recordset.length>0 && this.props.order.allOrderNumber.recordset.map((element,index)=>
          Orders.push(element)
        )}

        let Projects = []
        {this.props.project.allProjectNumber && this.props.project.allProjectNumber.recordset && this.props.project.allProjectNumber.recordset.length>0 && this.props.project.allProjectNumber.recordset.map((element,index)=>
          Projects.push(element)
        )}

        
        return(
            <div className="Container-fluid pageheight" >
                
               
               <div className="Container-fluid p-4" style={{opacity:this.state.opacity}}>
                  <div className="row">
                    <div className="col-md-10 row pr-4" style={{display:'flex'}}>
                      <div className="col-md-4" style={{display:'flex'}} >
                        {!roles[5]?<>
                          <label className="col-md-4 pt-2" >Supplier:  </label>
                          <DropdownFlat defaultopt="Select Option"  data={Vendors} actions={this.handleSelectSupplier} keyObjName={"VendorId"}  valueObjName={"VendorName"} /></>
                          :<div></div>
                        }  
                      </div>
                      
                      <div className="col-md-4" style={{display:'flex'}}>
                        <label className="col-md-4 pt-2" >OrderNo:  </label>
                          <DropdownFlat defaultopt="Select Option"  data={Orders} actions={this.handleSelectOrder} keyObjName={"OrderId"} valueObjName={"OrderNo"} />
                      </div>

                      <div className="col-md-4" style={{display:'flex'}}>
                        <label className="col-md-4 mr-2 pt-2" >ProjectNo:  </label>
                          <DropdownFlat defaultopt="Select Option"  data={Projects} actions={this.handleSelectProject} keyObjName={"ProjectId"} valueObjName={"ProjectNo"} />
                      </div>

                      {/* <div className="col-md-4" style={{display:'flex'}}>
                        <label className="col-md-4 mr-2 pt-2" >ItemNo:  </label>
                          <DropdownFlat defaultopt="Select Option"  data={Projects} actions={this.handleSelectProject} keyObjName={"ItemId"} valueObjName={"ItemNo"} />
                      </div> */}
                    </div>
                
                    <div className="col-md-2 row ml-2 pr-4 float-right" style={{display:'flex' }}>
                      <FontAwesomeIcon className="col-md-align-middle pr-2 mr-2" icon={"search"} onClick={this.handleSearch}  color={"black"} title="search" size="2x"/>
                      <FontAwesomeIcon className="col-md-align-middle pr-2 mr-3" icon={"redo"} onClick={this.handleRedo} color={"black"} title="refresh" size="2x"/>                    
                    </div>
                </div>
                <div>
                  <br />

          
                </div>
                  {/* </div> */}
<br />
<br />
<br />


                <div className="row-md-8 pr-4">
                    <div className="col ">
                        <div className="row  headerbar ">
                         {!roles[5]? <>
                            
                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">Order No</div>
                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">Project No</div>
                                <div className="col-md-3 pt-2 pb-2 borderheaderbar ">Supplier</div>
                                <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block">Created On</div>
                                {/* <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">Status</div> */}
                                <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">Action</div></>
                                :<>
                                <div className="col-md-3 pt-2 pb-2 borderheaderbar">Order No</div>
                                <div className="col-md-3 pt-2 pb-2 borderheaderbar">Project No</div>
                                <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block">Created On</div>
                                {/* <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">Status</div> */}
                                <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block">Action</div></>
                          }
                        </div>

                        {Tabledata.map((element,Index)=>
                        <div className={Index%2==0? 'row border ':'row  background '} 
                            onClick={()=>this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                         {!roles[5]? <> 
                            
                                <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">
                                <Link to= {{ pathname: '/DispatchProjectView',state : { orderNo: element.OrderNo, ordId: element.OrderId } }}>  
                                  {element.OrderNo}
                                </Link>
                                </div>                            
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">
                               <Link to= {{ pathname: '/DispatchProjectView',state : {projNo: element.ProjectNo, projId: element.ProjectId} }}>  
                                 {element.ProjectNo}
                               </Link>
                            </div>
                           <div className="col-md-3 pt-3 pb-2 borderheaderbar amount-text headeralign">
                             <Link to= {{ pathname: '/DispatchProjectView',state : {supName:element.Supplier, supId:element.VendorId} }}>  
                               {element.Supplier}
                             </Link>
                            </div>      
                           <div className="col-md-3 pt-3 pb-2 borderheaderbar d-none d-sm-block headeralign">{dateFormater(element.POCreatedOn)}</div>
                           {/* <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{element.Status}</div> */}
                           {/* <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.OrderNo}</div>
                           <div className="col-md-2 pt-2 pb-3 borderheaderbar headeralign">{element.ProjectNo}</div>
                           <div className="col-md-3 pt-2 pb-3 borderheaderbar amount-text headeralign">{element.Supplier}</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{dateFormater(element.POCreatedOn)}</div>
                           <div className="col-md-2 pt-2 pb-3 borderheaderbar d-none d-sm-block headeralign">{element.Status}</div> */}
                           <div className="col-md-2 pt-2 pb-3 borderheaderbar text-center d-none d-sm-block">            
                                <Link to= {{ pathname: '/DispatchProjectView',state : {orderNo: element.OrderNo, ordId: element.OrderId,projNo: element.ProjectNo, projId: element.ProjectId, supName:element.Supplier, supId:element.VendorId} }}><FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" /></Link>
                           </div>
                            </>
                            :
                            <>
                          <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.OrderNo} </div>                                                      
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">  {element.ProjectNo} </div>
                          <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{dateFormater(element.POCreatedOn)}</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar text-center d-none d-sm-block">            
                                <Link to= {{ pathname: '/DispatchProjectView',state : {orderNo: element.OrderNo, ordId: element.OrderId,projNo: element.ProjectNo, projId: element.ProjectId, supName:element.Supplier, supId:element.VendorId} }}><FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" /></Link>
                           </div>
                           </>
                         }
                             
                         
                          </div>
                        )}           
                    </div>
                </div>
            </div>
     </div>
                        
            
        )
    }
}

const mapStateToProps  = (state) => ({supplier:state.vendorReducer, project:state.project, order:state.order, orderDetails:state.orderDetails})
export default connect(mapStateToProps,{getAllSuppliers,getAllProjectNumber,getAllOrderNumber,getAllDetailsForDispatch}) (DispatchHome);